module.exports = __webpack_public_path__ + "media/images/common/ico-list-7a6120ef0c8f7d9a32f6c2a2be67abc0.svg";